export interface MovieItem {
  id: number;
  title: string;
  category: 'movie' | 'tv' | 'variety' | 'anime';
  subCategory: string;
  year: number;
  rating: number;
  poster: string;
  description: string;
  director: string;
  cast: string[];
  duration: string;
  quality: string[];
  updateInfo: string;
  isHot: boolean;
  isNew: boolean;
  featured: boolean;
}

export const categories = [
  { slug: 'movie', name: '电影', icon: 'ri-film-line' },
  { slug: 'tv', name: '电视剧', icon: 'ri-tv-line' },
  { slug: 'variety', name: '综艺', icon: 'ri-live-line' },
  { slug: 'anime', name: '动漫', icon: 'ri-ghost-line' },
];

export const subCategories: Record<string, string[]> = {
  movie: ['动作片', '喜剧片', '爱情片', '科幻片', '恐怖片', '剧情片', '战争片', '纪录片'],
  tv: ['国产剧', '港台剧', '日韩剧', '欧美剧', '海外剧'],
  variety: ['大陆综艺', '港台综艺', '日韩综艺', '欧美综艺'],
  anime: ['国产动漫', '日韩动漫', '欧美动漫', '剧场版'],
};

export const movies: MovieItem[] = [
  {
    id: 1,
    title: '流浪地球3',
    category: 'movie',
    subCategory: '科幻片',
    year: 2026,
    rating: 9.2,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20design%20for%20sci-fi%20film%20The%20Wandering%20Earth%203%2C%20dramatic%20space%20scene%20with%20Earth%20and%20massive%20engines%2C%20dark%20cosmic%20background%20with%20stars%2C%20Chinese%20film%20poster%20style%2C%20epic%20scale%2C%20warm%20orange%20and%20blue%20lighting%20contrast%2C%20cinematic%20composition&width=400&height=560&seq=movie-poster-01&orientation=portrait',
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。然而宇宙之路危机四伏，为了拯救地球，流浪地球时代的年轻人再次挺身而出，展开争分夺秒的生死之战。延续前作的宏大叙事，本作将呈现更加震撼的视觉奇观和深刻的人性探讨。',
    director: '郭帆',
    cast: ['吴京', '刘德华', '李雪健', '沙溢'],
    duration: '148分钟',
    quality: ['蓝光', '4K', '超清', '高清'],
    updateInfo: '2026-08-02 更新',
    isHot: true,
    isNew: true,
    featured: true,
  },
  {
    id: 2,
    title: '哪吒之魔童闹海',
    category: 'movie',
    subCategory: '动画片',
    year: 2025,
    rating: 9.5,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20poster%20Nezha%20character%20with%20fiery%20wheels%20and%20red%20ribbon%2C%20mythological%20Chinese%20style%2C%20dynamic%20action%20pose%2C%20ink%20wash%20painting%20inspired%20background%2C%20vibrant%20red%20and%20gold%20color%20scheme%2C%20epic%20fantasy%20movie%20poster%20design&width=400&height=560&seq=movie-poster-02&orientation=portrait',
    description: '天劫之后，哪吒、敖丙的灵魂虽保住了，但肉身很快会魂飞魄散。太乙真人打算用七色宝莲给二人重塑肉身。但是在重塑肉身的过程中却遇到重重困难，哪吒、敖丙的命运将走向何方？',
    director: '饺子',
    cast: ['吕艳婷', '囧森瑟夫', '瀚墨'],
    duration: '143分钟',
    quality: ['蓝光', '4K', '超清', '高清'],
    updateInfo: '2026-07-28 更新',
    isHot: true,
    isNew: false,
    featured: true,
  },
  {
    id: 3,
    title: '庆余年第二季',
    category: 'tv',
    subCategory: '国产剧',
    year: 2024,
    rating: 8.9,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20TV%20series%20poster%20Joy%20of%20Life%20Season%202%2C%20ancient%20Chinese%20palace%20setting%2C%20period%20costume%20drama%2C%20mysterious%20atmosphere%2C%20warm%20golden%20lighting%2C%20traditional%20Chinese%20aesthetic%2C%20refined%20composition&width=400&height=560&seq=movie-poster-03&orientation=portrait',
    description: '范闲在经历了上一季的种种遭遇后，终于迎来了人生的转折点。朝堂之上暗流涌动，江湖之中风波再起，范闲将如何应对这重重危机？本季剧情更加紧凑，人物关系更加复杂。',
    director: '孙皓',
    cast: ['张若昀', '李沁', '陈道明', '吴刚'],
    duration: '40分钟/集 共36集',
    quality: ['4K', '超清', '高清'],
    updateInfo: '2026-08-01 更新至36集',
    isHot: true,
    isNew: false,
    featured: true,
  },
  {
    id: 4,
    title: '封神第二部',
    category: 'movie',
    subCategory: '动作片',
    year: 2025,
    rating: 8.7,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20epic%20fantasy%20film%20poster%20Creation%20of%20the%20Gods%20sequel%2C%20ancient%20Chinese%20mythological%20warriors%20in%20battle%2C%20dramatic%20lighting%2C%20golden%20and%20crimson%20color%20palette%2C%20grand%20scale%20cinematic%20composition%2C%20traditional%20Chinese%20elements&width=400&height=560&seq=movie-poster-04&orientation=portrait',
    description: '姜子牙携众神帮助姬发伐纣，申公豹请来通天教主助纣为虐。一场三界浩劫，即将展开。殷商与西岐的大战愈演愈烈，各路神仙纷纷登场，正邪对决一触即发。',
    director: '乌尔善',
    cast: ['黄渤', '费翔', '李雪健', '夏雨'],
    duration: '152分钟',
    quality: ['蓝光', '4K', '超清', '高清'],
    updateInfo: '2026-07-25 更新',
    isHot: true,
    isNew: false,
    featured: false,
  },
  {
    id: 5,
    title: '繁花',
    category: 'tv',
    subCategory: '国产剧',
    year: 2024,
    rating: 9.1,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20TV%20drama%20poster%20Blossoms%20Shanghai%20set%20in%201990s%2C%20nostalgic%20Shanghai%20cityscape%2C%20neon%20lights%2C%20retro%20aesthetic%2C%20warm%20amber%20tones%2C%20romantic%20atmosphere%2C%20Wong%20Kar-wai%20style%20cinematography&width=400&height=560&seq=movie-poster-05&orientation=portrait',
    description: '九十年代的上海，处处是机遇与希望。青年阿宝凭借改革开放的春风和自己的努力，成为商界后起之秀。黄河路上热闹非凡，人人争上游，道尽一个时代的情义与至真。',
    director: '王家卫',
    cast: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾'],
    duration: '45分钟/集 共30集',
    quality: ['4K', '超清', '高清'],
    updateInfo: '2026-07-30 全30集',
    isHot: true,
    isNew: true,
    featured: false,
  },
  {
    id: 6,
    title: '间谍过家家 第三季',
    category: 'anime',
    subCategory: '日韩动漫',
    year: 2025,
    rating: 9.3,
    poster: 'https://readdy.ai/api/search-image?query=Anime%20poster%20Spy%20x%20Family%20season%203%2C%20stylish%20family%20of%20three%20with%20spy%20theme%2C%20clean%20illustration%20style%2C%20pastel%20color%20palette%20with%20dark%20accents%2C%20Japanese%20anime%20aesthetic%2C%20playful%20yet%20sophisticated%20composition&width=400&height=560&seq=movie-poster-06&orientation=portrait',
    description: '为了执行任务，黄昏、约尔和阿尼亚继续着他们的伪装家庭生活。然而，随着东国与西国的紧张关系加剧，一家人的秘密身份面临暴露的危险。本季将揭开更多关于实验体的神秘面纱。',
    director: '古桥一浩',
    cast: ['江口拓也', '种崎敦美', '早见沙织'],
    duration: '24分钟/集 共25集',
    quality: ['4K', '超清', '高清'],
    updateInfo: '2026-07-29 更新至12集',
    isHot: false,
    isNew: true,
    featured: false,
  },
  {
    id: 7,
    title: '狂飙',
    category: 'tv',
    subCategory: '国产剧',
    year: 2023,
    rating: 9.4,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20TV%20series%20poster%20The%20Knockout%2C%20intense%20police%20versus%20gangster%20theme%2C%20dark%20moody%20lighting%2C%20urban%20Chinese%20setting%2C%20gritty%20realistic%20style%2C%20strong%20contrast%20black%20and%20warm%20tones&width=400&height=560&seq=movie-poster-07&orientation=portrait',
    description: '京海市一线刑警安欣，在与黑恶势力的斗争中，不断遭到保护伞的打击，始终无法将犯罪分子绳之以法。全国政法队伍教育整顿工作开展后，临江省派出指导组入驻京海，联合公检法司各部门，清除了政法队伍内部的腐败分子。',
    director: '徐纪周',
    cast: ['张译', '张颂文', '李一桐', '张志坚'],
    duration: '45分钟/集 共39集',
    quality: ['4K', '超清', '高清'],
    updateInfo: '2026-07-20 全39集',
    isHot: false,
    isNew: false,
    featured: false,
  },
  {
    id: 8,
    title: '海贼王',
    category: 'anime',
    subCategory: '日韩动漫',
    year: 1999,
    rating: 9.5,
    poster: 'https://readdy.ai/api/search-image?query=One%20Piece%20anime%20poster%20Luffy%20and%20crew%20adventure%20on%20the%20sea%2C%20colorful%20pirate%20theme%2C%20blue%20ocean%20background%2C%20dynamic%20action%20composition%2C%20Japanese%20anime%20illustration%20style%2C%20vibrant%20colors%2C%20iconic%20Straw%20Hat%20pirates&width=400&height=560&seq=movie-poster-08&orientation=portrait',
    description: '路飞和他的草帽海贼团继续在大海上冒险，寻找传说中的ONE PIECE。经历了和之国的激战后，新的冒险篇章即将展开。路飞的实力达到了前所未有的高度，五档形态震撼登场。',
    director: '长峰达也',
    cast: ['田中真弓', '中井和哉', '冈村明美'],
    duration: '24分钟/集 持续更新',
    quality: ['超清', '高清'],
    updateInfo: '2026-08-02 更新至1123集',
    isHot: true,
    isNew: true,
    featured: false,
  },
  {
    id: 9,
    title: '奔跑吧 第十二季',
    category: 'variety',
    subCategory: '大陆综艺',
    year: 2026,
    rating: 8.5,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20Keep%20Running%20season%2012%2C%20energetic%20group%20of%20celebrities%20running%2C%20bright%20colorful%20design%2C%20outdoor%20adventure%20theme%2C%20joyful%20atmosphere%2C%20dynamic%20composition%2C%20Chinese%20entertainment%20show%20style&width=400&height=560&seq=movie-poster-09&orientation=portrait',
    description: '全新一季奔跑吧集结了众多明星嘉宾，继续带给大家欢乐与感动。本季节目设置了更多创新游戏和互动环节，嘉宾阵容更加强大，精彩程度全面升级。',
    director: '姚译添',
    cast: ['李晨', '郑恺', '沙溢', '白鹿'],
    duration: '90分钟/期',
    quality: ['4K', '超清', '高清'],
    updateInfo: '2026-08-01 更新至第8期',
    isHot: true,
    isNew: true,
    featured: false,
  },
  {
    id: 10,
    title: '三体',
    category: 'tv',
    subCategory: '国产剧',
    year: 2023,
    rating: 8.8,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20TV%20series%20poster%20Three-Body%20Problem%2C%20cosmic%20scale%20with%20three%20suns%2C%20mysterious%20alien%20civilization%20theme%2C%20dark%20blue%20and%20gold%20color%20scheme%2C%20cerebral%20sci-fi%20aesthetic%2C%20minimalist%20Chinese%20design&width=400&height=560&seq=movie-poster-10&orientation=portrait',
    description: '纳米科学家汪淼被警官史强带到联合作战中心，并潜入名为"科学边界"的组织协助调查。在调查过程中，汪淼接触到一个名为ETO的组织，发现其幕后主使竟是自杀的科学家杨冬的母亲叶文洁。随着调查的深入，一个关于三体文明和地球未来的惊天秘密逐渐浮出水面。',
    director: '杨磊',
    cast: ['张鲁一', '于和伟', '陈瑾', '王子文'],
    duration: '45分钟/集 共30集',
    quality: ['4K', '超清', '高清'],
    updateInfo: '2026-07-22 全30集',
    isHot: false,
    isNew: false,
    featured: true,
  },
  {
    id: 11,
    title: '速度与激情11',
    category: 'movie',
    subCategory: '动作片',
    year: 2026,
    rating: 8.3,
    poster: 'https://readdy.ai/api/search-image?query=Hollywood%20action%20movie%20poster%20Fast%20and%20Furious%2011%2C%20fast%20cars%20racing%20in%20city%2C%20explosive%20action%20scene%2C%20dark%20urban%20background%20with%20neon%20lights%2C%20adrenaline%20fueled%20composition%2C%20cinematic%20blockbuster%20style&width=400&height=560&seq=movie-poster-11&orientation=portrait',
    description: '唐老大和他的家族再次面临新的威胁。这一次，敌人来自他们意想不到的地方。在全球多个城市展开的极速追逐战中，家族成员们将经历前所未有的考验。',
    director: '路易斯·莱特里尔',
    cast: ['范·迪塞尔', '杰森·斯坦森', '米歇尔·罗德里格兹'],
    duration: '141分钟',
    quality: ['蓝光', '4K', '超清', '高清'],
    updateInfo: '2026-07-26 更新',
    isHot: false,
    isNew: true,
    featured: false,
  },
  {
    id: 12,
    title: '向往的生活 第九季',
    category: 'variety',
    subCategory: '大陆综艺',
    year: 2026,
    rating: 8.6,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20Back%20to%20Field%20season%209%2C%20rustic%20countryside%20farmhouse%20setting%2C%20warm%20natural%20lighting%2C%20peaceful%20rural%20Chinese%20landscape%2C%20cozy%20homestead%20atmosphere%2C%20organic%20farm%20to%20table%20lifestyle%2C%20gentle%20pastoral%20aesthetic&width=400&height=560&seq=movie-poster-12&orientation=portrait',
    description: '新一季的蘑菇屋来到了美丽的云南大理。何老师和黄老师带着新老朋友们在苍山洱海间体验田园生活，自给自足，招待远道而来的客人们。远离城市喧嚣，回归生活本真。',
    director: '王征宇',
    cast: ['何炅', '黄磊', '张艺兴', '彭昱畅'],
    duration: '90分钟/期',
    quality: ['4K', '超清', '高清'],
    updateInfo: '2026-08-02 更新至第6期',
    isHot: false,
    isNew: true,
    featured: false,
  },
  {
    id: 13,
    title: '满江红',
    category: 'movie',
    subCategory: '剧情片',
    year: 2023,
    rating: 8.4,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20mystery%20film%20poster%20Full%20River%20Red%2C%20Song%20dynasty%20setting%20with%20ancient%20Chinese%20architecture%2C%20crimson%20and%20black%20color%20scheme%2C%20suspenseful%20atmosphere%2C%20traditional%20Chinese%20visual%20style%2C%20dramatic%20shadow%20play&width=400&height=560&seq=movie-poster-13&orientation=portrait',
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。小兵张大与亲兵营副统领孙均机缘巧合被裹挟进巨大阴谋之中。宰相秦桧命两人限一个时辰之内找到凶手。伴随危机四伏的深入调查，真相逐渐浮出水面。',
    director: '张艺谋',
    cast: ['沈腾', '易烊千玺', '张译', '雷佳音'],
    duration: '159分钟',
    quality: ['蓝光', '4K', '超清', '高清'],
    updateInfo: '2026-07-15 更新',
    isHot: false,
    isNew: false,
    featured: false,
  },
  {
    id: 14,
    title: '鬼灭之刃 锻刀村篇',
    category: 'anime',
    subCategory: '日韩动漫',
    year: 2023,
    rating: 9.0,
    poster: 'https://readdy.ai/api/search-image?query=Anime%20poster%20Demon%20Slayer%20Swordsmith%20Village%20arc%2C%20Japanese%20warrior%20with%20katana%20in%20action%2C%20fire%20and%20water%20breathing%20effects%2C%20traditional%20Japanese%20village%20background%2C%20dynamic%20combat%20scene%2C%20vibrant%20anime%20art%20style&width=400&height=560&seq=movie-poster-14&orientation=portrait',
    description: '在游郭篇事件后，炭治郎前往锻刀村寻找新的日轮刀。在那里，他遇到了恋柱甘露寺蜜璃和霞柱时透无一郎。然而，上弦之鬼的到来打破了村子的宁静，一场激战即将展开。',
    director: '外崎春雄',
    cast: ['花江夏树', '鬼头明里', '河西健吾'],
    duration: '24分钟/集 共11集',
    quality: ['蓝光', '4K', '超清', '高清'],
    updateInfo: '2026-07-18 全11集',
    isHot: false,
    isNew: false,
    featured: false,
  },
  {
    id: 15,
    title: '歌手2026',
    category: 'variety',
    subCategory: '大陆综艺',
    year: 2026,
    rating: 8.2,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20music%20competition%20show%20poster%20Singer%202026%2C%20spotlight%20stage%20with%20microphone%2C%20dramatic%20concert%20lighting%2C%20dark%20background%20with%20golden%20accents%2C%20premium%20music%20show%20aesthetic%2C%20elegant%20and%20powerful%20visual&width=400&height=560&seq=movie-poster-15&orientation=portrait',
    description: '顶级音乐竞演节目回归！本季邀请了两岸三地及海外的顶级歌手同台竞技，用音乐传递情感与力量。每一期都有惊喜嘉宾助阵，舞台效果全面升级，打造视听盛宴。',
    director: '洪涛',
    cast: ['那英', '张杰', '华晨宇', '邓紫棋'],
    duration: '120分钟/期',
    quality: ['4K', '超清', '高清'],
    updateInfo: '2026-08-01 更新至第7期',
    isHot: false,
    isNew: true,
    featured: false,
  },
  {
    id: 16,
    title: '奥本海默',
    category: 'movie',
    subCategory: '剧情片',
    year: 2023,
    rating: 9.0,
    poster: 'https://readdy.ai/api/search-image?query=Hollywood%20biopic%20film%20poster%20Oppenheimer%2C%20mushroom%20cloud%20silhouette%20against%20orange%20sky%2C%20black%20and%20white%20portrait%20style%2C%20intense%20dramatic%20mood%2C%20historical%20serious%20tone%2C%20minimalist%20powerful%20composition&width=400&height=560&seq=movie-poster-16&orientation=portrait',
    description: '罗伯特·奥本海默，这位被称为"原子弹之父"的天才物理学家，在曼哈顿计划中扮演了关键角色。影片全景式展现了这位复杂人物的传奇一生，深入探讨了科学、道德与权力之间的永恒冲突。',
    director: '克里斯托弗·诺兰',
    cast: ['基里安·墨菲', '艾米莉·布朗特', '马特·达蒙'],
    duration: '180分钟',
    quality: ['蓝光', '4K', '超清', '高清'],
    updateInfo: '2026-07-10 更新',
    isHot: false,
    isNew: false,
    featured: false,
  },
];